module.exports = __webpack_public_path__ + "img/4_2.15576500.png";